import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';

const Tips0Field: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	if (customerForFullInfo?.defaultTips[0]) {
		return (
			<FullInfoField
				label={customerForFullInfo.defaultTips[0].isDefault ? 'tips0DefaultLabel' : 'tips0Label'}
				value={customerForFullInfo.defaultTips[0].value}
			/>
		);
	}
	return <FullInfoField label="tips0Label" value={null} />;
};

export default Tips0Field;
